module.exports = __webpack_public_path__ + "static/media/1.e701c3d4.png";


//////////////////
// WEBPACK FOOTER
// ./src/layers/male/beards/1.png
// module id = 1177
// module chunks = 0